<template>
	<div class="icp" v-if="!configStore.electronMode">
		<div class="icp-content">
			<p class="icp-company">
				<span>© {{ currentYear }} {{ companyName }}</span>
				<span class="icp-rights">版权所有</span>
			</p>
			<div class="icp-record" v-if="icpNo">
				<img class="icp-icon" src="../../assets/image/icp_logo.png" alt="备案图标">
				<a target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn/">{{ icpNo }}</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		currentYear() {
			return new Date().getFullYear();
		},
		companyName() {
			return process.env.VUE_APP_COMPANY_NAME;
		},
		icpNo() {
			return process.env.VUE_APP_ICP_NO;
		}
	}
}
</script>

<style lang="scss">
.icp {
	position: fixed;
	bottom: 16px;
	left: 0;
	display: flex;
	justify-content: center;
	width: 100%;
	z-index: 2;

	.icp-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 6px;
		padding: 0 12px;
		text-align: center;
	}

	.icp-company {
		margin: 0;
		font-size: 12px;
		font-weight: 600;
		line-height: 1.5;
		color: #475569;
		letter-spacing: 0.2px;
	}

	.icp-rights {
		margin-left: 6px;
		font-weight: 400;
		color: #94a3b8;
	}

	.icp-record {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		line-height: 1;
	}

	.icp-icon {
		width: 14px;
		height: 14px;
		opacity: 0.85;
	}

	a {
		font-size: 13px;
		font-weight: 400;
		line-height: 1;
		color: #64748b;
		text-decoration: none;
		transition: color 0.2s ease;
	}

	a:hover {
		color: var(--im-color-link);
	}

	@media (max-width: 768px) {
		bottom: 12px;

		.icp-company {
			font-size: 11px;
		}

		a {
			font-size: 12px;
		}
	}
}
</style>